var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 38,
    viewBox: "0 0 144 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart reate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0.467773 23.2519H17.023L19.1592 19.6363L21.8293 25.6623L28.7719 4.57141L35.7143 37.7143L38.9186 19.6363L42.1229 25.6623L44.259 23.2519H57.076",
    stroke: "#40DBC1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M46.7834 23.2519H65.1226L67.2185 19.6363L69.8383 25.6623L76.65 4.57141L83.4617 37.7143L86.6056 19.6363L89.7497 25.6623L91.8452 23.2519H104.421",
    stroke: "#40DBC1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M92.0701 23.2519H110.449L112.55 19.6363L115.176 25.6623L122.002 4.57141L128.829 37.7143L131.98 19.6363L135.13 25.6623L137.231 23.2519H143.532",
    stroke: "#40DBC1",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartreate);
export default __webpack_public_path__ + "static/media/Heart reate.fc7e35bafa7f7f8a2220d2557ecdd32a.svg";
export { ForwardRef as ReactComponent };